const isLeftToRight = '[dir="ltr"] & ';
const isRightToLeft = '[dir="rtl"] & ';
const ignoreRTL = '[dir] & ';

export { ignoreRTL, isLeftToRight, isRightToLeft };
